import { render } from "./Attachments.vue?vue&type=template&id=bd8e19e6&ts=true"
import script from "./Attachments.vue?vue&type=script&lang=ts"
export * from "./Attachments.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__